import { HubConnectionBuilder,LogLevel} from '@microsoft/signalr';

const createConnection = (hubUrl) => {
  const connection = new HubConnectionBuilder()
    .withUrl(hubUrl)
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information) 
    .build();

  return connection;
};

export default createConnection;